export default {
    routerName: '画像管理',
    pic: {
        searchName: '検索条件',
        name: '画像名',
        status: '状態',
        open: '有効',
        close: '無効',
        sortOrder: 'ソート',
        createTime: '作成日付',
        createStartTime: '作成開始日付',
        createEndTime: '作成終了日付',
        searchButton: '検索',
    },
    table: {
        id: 'ID',
        name: '画像名',
        thumb: 'サムネイル',
        sortOrder: 'ソート',
        createBy: '作成者',
        createTime: '作成日付',
        status: '状態',
    },
};
